import { ThemeProvider as ConcordeThemeProvider } from '@epilot/concorde-elements'
import type { PropsWithChildren } from 'react'

import classes from '../JourneyPage/components/LinearJourney.module.scss'
import { useThemes } from '../JourneyPage/use-themes'

type JourneyLauncherTabsThemeProviderProps = PropsWithChildren<{
  isFocusedOnJourney: boolean
}>

export const JourneyLauncherTabsThemeProvider = (
  props: JourneyLauncherTabsThemeProviderProps
) => {
  const { concordeTheme, designTokens } = useThemes()

  return (
    <ConcordeThemeProvider designTokens={designTokens} theme={concordeTheme}>
      <div className={classes.concordeStepContainer}>{props.children}</div>
    </ConcordeThemeProvider>
  )
}
